"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMeasuresContext = useMeasuresContext;
exports.MeasuresProvider = MeasuresProvider;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MeasuresContext = (0, _react.createContext)(null);

function useMeasuresContext() {
  var context = (0, _react.useContext)(MeasuresContext);

  if (!context) {
    throw new Error('Do not use measurable components outside of the MeasuresContext');
  }

  return context;
}

function MeasuresProvider(_ref) {
  var measures = _ref.measures,
      children = _ref.children;
  return _react2.default.createElement(MeasuresContext.Provider, {
    value: measures
  }, children);
}